import React, { useContext, useEffect, useState } from 'react';
import default_avatar from "../../assets/images/default-avatar.jpg";
import Icon from '@mdi/react';
import { mdiCloseCircle } from '@mdi/js';
import instance from '../../api/api';
import { defaultUserData, IOption, IRelation } from '../../interfaces/family';
import { Modal } from 'react-bootstrap';
import { Context } from '../../pages/home.page';
import { IUserDetails } from '../../interfaces/authentication';
import Notification, { notificationImages } from '../notifications/notification.component';
import { INotification, NotificationType } from '../../interfaces/notification';
import { profileTypes } from '../../_helper/enum/enum';
import config from '../../config/config';

interface IProps {
    userid:string
    successors: IUserDetails[]
    relations: IRelation[]
}

const successNotificationData: INotification = { icon: notificationImages.like, title: "Success", text: "Successfully added a successor", success: NotificationType.success }
const errorNotificationData: INotification = { icon: notificationImages.crying, title: "Fail", text: "Failed to update successors", success: NotificationType.problem }

/**
 * 
 * @param props :  interface
 * @returns void
 */
function SelectSuccessor(props:IProps) {

    const [ successors, setSuccessors ] = useState<IOption[]>([]);
    const [ familyMembers, setFamilyMembers ] = useState<IRelation[]>([]);
    const [ search, setSearch ] = useState<string>('');

    const [ selected, setSelected ] = useState<IOption>({_id:"", text:"", img:""})

    //Notifications
    const [ notification, setNotification ] = useState<boolean>(false);
    const [ errorNotification, setErrorNotification ] = useState<boolean>(false);

    const [ updateByInComponentState, setUpdateByInComponentState ] = useState<IUserDetails>(defaultUserData);

    //Modal
    const [ show, setShow ] = useState<boolean>(false);

    const loggedInUserData = useContext(Context).user;    
    const updateLoggedInUserData = useContext(Context).setUserDetails;

    useEffect(() => {
        getUserinfo(props.relations, props.successors);
    }, [props.relations, props.successors])

    useEffect(() => {   
        if (updateByInComponentState._id.length) {
            getUserinfo(updateByInComponentState.relations, updateByInComponentState.successors);
        }
    }, [updateByInComponentState])


    async function getUserinfo(relations:IRelation[], successors:IUserDetails[]) {
        const people: IOption[] = successors.map((successor : IUserDetails) => { return {_id:successor._id, text: `${successor.firstname} ${successor.lastname}`, img:successor.avatar ? successor.avatar : ''}})
        const peopleIds = people.map(successor => successor._id)       
        setSuccessors(people);
        
        // only an Adult can be a Successor
        const canBeSuccessors = relations.filter((member:IRelation) => member.userid.profileType === profileTypes.ADULT).filter((member:IRelation) => !peopleIds.includes(member.userid._id))
        setFamilyMembers(canBeSuccessors);
    }

    async function updateSuccessors(people:string[]) {
        try {
            const response = await instance.put('/user/' + props.userid, {details: {successors: people}});

            // update Context only if this is Me
            if(props.userid===loggedInUserData._id) {
                updateLoggedInUserData(response.data);
            } else {
                setUpdateByInComponentState(response.data);
            }

            setNotification(true);
        }
        catch(error) {
            setErrorNotification(true);
        }
    }

    async function addSuccessor() {
        let admins = [...successors, selected];
        if(!successors.map(x => x._id).includes(selected._id)) {
            await updateSuccessors(admins.map(x => x._id));
        } else {
            setErrorNotification(true);        
        }

        setTimeout(() => {
            setShow(false);
            setNotification(false);
            setErrorNotification(false);
            setSearch('');
            setSelected({_id:"", text:"", img:""});
        }, config.modalCloseTimeout);
    }

    async function removeSuccessor(successor:IOption) {
        try {
            let admins = successors.filter(data => data._id !== successor._id);
            await updateSuccessors(admins.map(x => x._id));
            setNotification(true);
        }
        catch(error) {
            setErrorNotification(true);
        }

        setTimeout(() => {
            setShow(false);
            setNotification(false);
            setErrorNotification(false);
        }, config.modalCloseTimeout);
    }

    function closeModal() {
        setShow(false);
        setNotification(false);
        setErrorNotification(false);
    }

    return(
        <div className="select-successor-container">
            <div className="group">
                <input className="admin-select" placeholder="Search name" value={search} onChange={(evt) => setSearch(evt.target.value)}></input>
                <p className="top-label">Search name</p>
            </div>
            {search.length ? 
            <div className="avalible-family-members">
                {familyMembers.filter((member:IRelation) => member.userid.firstname.match(new RegExp(search, "i")) || member.userid.lastname.match(new RegExp(search, "i"))).map(member => {
                    return(<p onClick={() => {setSelected({_id:member.userid._id, text: ` ${member.userid.firstname} ${member.userid.lastname}`, img: member.userid.avatar ? member.userid.avatar : ""}); setShow(true)}}>{member.userid.firstname} {member.userid.lastname}</p>);
                })}
            </div> : null}
            {successors.length ? 
            <div className="successors">
                {successors.map((successor:IOption) => {
                    return(
                        <div key={successor._id} className="admin-info">
                            <div className="profile">
                                <img src={successor.img ? successor.img : default_avatar} className="user-picture" alt="profile"></img>
                                <p>{successor.text}</p>
                            </div>
                            <span onClick={() => removeSuccessor(successor)}><Icon size={1} path={ mdiCloseCircle } /></span>
                        </div>
                    )
                })}
            </div> : null }
            <Modal dialogClassName="administrator-modal" show={show} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>Authorisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="content-title">Adding a successor</p>
                    <img className="user-picture" src={selected.img ? selected.img : default_avatar} alt="admin-avatar"/>
                    <p className="name">{selected.text}</p>
                    <p className="info-text">Upon my death, I hereby grant Successors management rights on my profile and family contacts, as described in the <a className="underlined-link-button" href="/dashboard/terms">Terms & Privacy</a></p>
                    <button className="default-button" disabled={!selected._id.length} onClick={() => addSuccessor()}>Grant successor access</button>                      
                    {notification ? <Notification data={successNotificationData} close={() => setNotification(false)}/> : null}
                    {errorNotification ? <Notification data={errorNotificationData} close={() => setErrorNotification(false)}/> : null}                    
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SelectSuccessor;